<template>
  <el-card
    :loading="loading"
    :body-style="{ padding: '14px 16px 8px' }"
    :bordered="false"
    shadow="hover"
  >
    <div class="chart-card-header">
      <div class="meta">
        <span class="chart-card-title">{{ title }}</span>
        <span class="chart-card-action">
          <slot name="action"></slot>
        </span>
      </div>
      <div class="total">
        <span v-if="custFont" class="minusFont">{{ total }}</span>
        <span v-else class="normalFont">{{ total }}</span>
      </div>
    </div>
    <div class="chart-card-content">
      <div class="content-fix">
        <slot></slot>
      </div>
    </div>
    <!-- <div class="chart-card-footer">
      <div class="field">
        <slot name="footer"></slot>
      </div>
    </div> -->
  </el-card>
</template>

<script>
export default {
  name: 'ChartCard',
  props: {
    title: {
      type: String,
      default: '',
    },
    total: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    custFont: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="stylus">
@import '../../assets/css/common-color.styl'
  .chart-card-header
    position relative
    overflow hidden
    width 100%
    .meta
      position relative
      overflow hidden
      width 100%
      color rgba(0, 0, 0, .45)
      font-size 12px
      line-height 22px
      .chart-card-action
        cursor pointer
        position absolute
        top 0
        right 0
    .total
      span
        overflow hidden
        text-overflow ellipsis
        word-break break-all
        white-space nowrap
        margin-top 4px
        margin-bottom 0
        line-height 38px
        height 38px
        font-family DINPro
        color gray01
      .minusFont
        font-size 26px
      .normalFont
        font-size 32px
  .chart-card-footer
    border-top 1px solid #e8e8e8
    padding-top 9px
    margin-top 8px
    font-size 10px
    > *
      position relative
    .field
      white-space nowrap
      overflow hidden
      text-overflow ellipsis
      margin 0
  .chart-card-content
    margin-bottom 12px
    position relative
    height 86px
    width 100%
    .content-fix
      position absolute
      left 0
      bottom 0
      width 100%
</style>
